import EnvVariableContainer from './EnvVariableProvider';
export default EnvVariableContainer;
